Vue.component('app-game-player-menu', {
    mounted: function() {
        game.playerMenuComponent = this;
    },
    data: function() {
        return {
            shouldShowModal: false,
            state: null,
            reportReason: '',
            player: null,
            canKickPlayer: false
        };
    },
    methods: {
        showModal: function(val) {
            this.shouldShowModal = val;
        },
        openPlayerMenu: function(player, currentPlayer) {
            this.player = player;
            this.state = null;
            this.reportReason = '';
            this.reportDetails = '';
            this.canKickPlayer = !!(currentPlayer && currentPlayer.isTeamLeader && currentPlayer.team === player.team);
            this.showModal(true);
        },
        kick: function() {
            game.mainSocket.emit('lobbyKickPlayer', this.player.clientId);
            this.showModal(false);
        },
        report: function() {
            this.state = 'report';
        },
        sendReport: function() {
            if (this.reportDetails && this.reportDetails.length > 12) {
                game.mainSocket.emit('reportPlayer', {
                    clientId: this.player.clientId,
                    reason: this.reportReason + '\nDetails: ' + this.reportDetails
                });
                this.reportReason = '';
                this.reportDetails = '';
                this.showModal(false);
            } else {
                game.showGrowl('Report reason must be longer than 12 characters.', {type: 'danger'});
            }
        }
    },
    template: `
    <div class="game-modal" v-if="shouldShowModal">
        <div class="game-modal-content game-modal-content-sm">
            <button type="button" v-on:click="showModal(false)" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <div v-if="!state">
                <h2><i class="fa fa-user"></i> {{player.name}}</h2>
                <button type="button" v-if="canKickPlayer" class="app-btn app-btn-secondary" v-on:click="kick()">
                    <i class="fa fa-ban"></i> Kick Player
                </button>
                <button type="button" class="app-btn app-btn-secondary" v-on:click="report()">
                    <i class="fa fa-flag"></i> Report Player
                </button>
                <br><br>
                <button type="button" class="app-btn app-btn-danger" v-on:click="showModal(false)">
                    <i class="fa fa-close"></i> Close
                </button>
            </div>
            <div v-if="state === 'report'">
                <h2><i class="fa fa-flag"></i> Report Player</h2>
                <p>Report a player for misconduct, including but not limited to:</p>
                <ul>
                    <li>Insulting or harassing others</li>
                    <li>Sabotaging or griefing their own team</li>
                    <li>Using cheats</li>
                    <li>Playing with multiple accounts</li>
                </ul>
                <p>Reports are taken seriously, and could result in a ban. Do not abuse the report system, false reports may also result in a ban.</p>
                <br>
                <h4>Player: {{player.name}}</h4>
               
                <div class="form-group">
                    <select class="app-input" v-model="reportReason">
                        <option value="">- Select a Reason -</option>
                        <option>Insulting or harassing others</option>
                        <option>Sabotaging or griefing their own team</option>
                        <option>Using cheats</option>
                        <option>Playing with multiple accounts</option>
                    </select>
                    <label style="width:100%;" v-if="reportReason">
                        <b>Report Reason:</b>
                        <textarea class="form-control" v-model="reportDetails" name="reportMessage"></textarea>
                    </label>
                </div>
                <br>
                <button type="button" class="app-btn app-btn-secondary" v-on:click="sendReport()">
                    <i class="fa fa-flag"></i> Send Report
                </button>
                <br><br>
                <button type="button" class="app-btn app-btn-danger" v-on:click="state = null">
                    <i class="fa fa-close"></i> Cancel
                </button>
            </div>
        </div>
    </div>
    `
})